import { Space, Table, Tag, message } from "antd";
import type { ColumnsType } from "antd/es/table/interface";
import { useTranslation } from "react-i18next";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import {
  deleteItemModifier,
  getItemModifierById,
} from "../../../api/itemModifiers";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { useEffect, useState } from "react";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import EditButton from "../../UI/EditButton/editbutton";
import { ItemModifierType } from "./ItemModifierType";
import { AddEditItemModifier } from "./addEditModifier";
import { getmodifiersDropdown } from "../../../api/modifier";
import { useParams } from "react-router";
import { AxiosResponse } from "axios";

interface ItemComponentProps {
  ItemModifierMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      itemid: string | number | undefined;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  paginatedModifiersComponent: any;
  setPaginatedModifiersComponent: any;
  filter: any;
  search: any;
  isItemModifierLoading: boolean;
}

interface ItemModifierInterface {
  id: number;
  guid: string;
  modifier: string;
  price: number;
  notes: string;
}

const ItemModifierList = ({
  ItemModifierMutation,
  paginatedModifiersComponent,
  setPaginatedModifiersComponent,
  filter,
  search,
  isItemModifierLoading,
}: ItemComponentProps) => {
  const { id } = useParams();
  const [t] = useTranslation("common");

  useEffect(() => {
    ItemModifierMutation({
      itemid: id,
      q: search,
      isActive: filter,
    })
      .then((res) => {
        setPaginatedModifiersComponent(res.data);
      })
      .catch((error) => {
        // Handle error
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, id]);

  const deleteItemModifierMutation = useMutation(
    "deleteItemModifier",
    deleteItemModifier,
    {
      onSuccess: () => {
        ItemModifierMutation({
          itemid: id,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedModifiersComponent(res.data);
          message.success("Complete successfully");
        });
      },
    }
  );
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [, setNameToDelete] = useState<any>();

  const DeleteItemModifier = (
    id: string | undefined,
    component: string
  ): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(component);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteItemModifierMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const [itemModifier, setItemModifier] = useState<ItemModifierType>();
  const [openItemModifier, setOpenItemModifier] = useState(false);
  const [selectedItemModifier, setSelectedItemModifier] = useState<any>();

  const getModifierMutation = useMutation(
    "getItemModifier",
    getItemModifierById
  );
  function fillItemModifier(id: any) {
    getModifierMutation.mutate(id, {
      onSuccess: (res) => {
        setItemModifier(res.data);
        setOpenItemModifier(true);
      },
    });
  }
  const [formatedItemModifier, setFormatedItemModifier] = useState<{}[]>();
  const { isLoading: loadingItemModifier } = useQuery(
    "getmodifiers",
    getmodifiersDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemModifier(
          res.data.map((modifier: any) => {
            return { value: modifier.id, label: modifier.name };
          })
        );
      },
    }
  );

  const columns: ColumnsType<ItemModifierInterface> = [
    {
      title: `${t("name")}`,
      dataIndex: "modifier",
      key: "modifier",
      width: "25rem",
      render: (record: any) => {
        return record ? record.name : null;
      },
    },
    {
      title: `${t("price")}`,
      dataIndex: "price",
      key: "price",
      width: "8rem",
    },
    {
      title: `${t("note")}`,
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      key: "isActive",
      width: "5rem",
      align: "center",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },

    {
      title: `${t("action")}`,
      fixed: "right",
      width: "5rem",
      align: "center",
      render: (record: any) => (
        <Space>
          <EditButton
            onClick={() => {
              setSelectedItemModifier(record.id);
              fillItemModifier(record.id);
            }}
          />
          <DeleteButton
            onClick={() => DeleteItemModifier(record?.id, record?.component)}
          />
        </Space>
      ),
    },
  ];
  return (
    <>
      {openItemModifier && itemModifier && (
        <AddEditItemModifier
          itemid={id}
          loadingItemModifier={loadingItemModifier}
          formatedItemModifier={formatedItemModifier}
          itemModifier={itemModifier}
          openItemModifier={openItemModifier}
          setOpenItemModifier={setOpenItemModifier}
          id={selectedItemModifier}
          ItemModifierMutation={ItemModifierMutation}
          setPaginatedModifiersComponent={setPaginatedModifiersComponent}
          filter={filter}
          search={search}
          ItemID={id}
        />
      )}
      <DeleteModal open={open} setOpen={setOpen} name={""} onOk={handleOk} />
      <Table
        loading={isItemModifierLoading}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={paginatedModifiersComponent}
        pagination={{ pageSize: 8 }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default ItemModifierList;
